module.exports = __webpack_public_path__ + "static/img/logo3.760dde4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo3.png
// module id = 8z+w
// module chunks = 2